import { use, useEffect, useRef, useState } from "react";
import MainDashboardFilters from "../dashboardfilters/maindashboardfilters";
import MainSearch from "../dashboardfilters/mainsearch";
import MainTable from "../tables/maintable";
import api from "../api/api";
import dayjs from "dayjs";
import { Backdrop, CircularProgress } from "@mui/material";
import CrudTable from "../tables/crudtable";
import { useLocation, useParams } from "react-router-dom";
import ToastMessage from "../utils/muitoast";
import EditSelected from "../tables/Modals/editselected";
import MissingData from "../tables/Modals/missingdata";
import Deletemodal from "../tables/Modals/delete";
import ReplayIcon from '@mui/icons-material/Replay';
import EquipmentTable from "../tables/equipmenttable";
import { set } from "date-fns";
import { EmployeeIcon, SettingIcon } from "../utils/svgs/svgs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
const ViewTimeSheet=()=>{
      const [isModal,setIsModal]=useState (false)
      const [filterby,setFilterBy]=useState({name:"No Grouping",value:"NO_GROUPING"})
      const [tableLoading, setTableLoading] = useState(false);
      const [tableData, setTableData] = useState([]);
      const [editedRows, setEditedRows] = useState({});
        const [selectedRows, setSelectedRows] = useState([]);
          const[isDecimal,setIsDecimalMode]=useState(false)
        const[tab,setTab]=useState('emp')
        const [errorfields,setErrorFields]=useState([])
      const [editmodal,setEditmodal]=useState(false)
      const [currentfilter,setCurrentFilter]=useState('All')
      const [loader,setLoader]=useState(false)
      const [alertmessage, setAlertMessage] = useState('');
      const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    clock_in: "",
    clock_out: "",
    job_id: "",
    cost_code_id: "",
    break_time: "",
    perdim: "",
    hours:''
  });
     
      const [missingdatamodal,setMissingdatamodal]=useState(false)
      const [severity, setSeverity] = useState('success');
      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };
    const location =useLocation()
      const queryParams = new URLSearchParams(location.search);
  const [activeFilter, setActiveFilter] = useState({label:'All'});
      const companyid = queryParams.get("companyid");
      const [debounceTimer, setDebounceTimer] = useState(null);
      const supervisorid = queryParams.get("supervisorid");
      const date = queryParams.get("date");
      const [selectedDate, setSelectedDate] = useState(new Date(`${date}T00:00:00`));
const [isoldbuild,setOldbuild]=useState(true)
   const searchquery=useRef('')
     const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
const [counts,setCounts]=useState([
 { label: "All", empKey: "total_count", eqpKey: "eqp_all_count", count: 0 },
  { label: "Pending", empKey: "pending_count", eqpKey: "eqp_pending_count", count: 0 },
  { label: "Submitted", empKey: "submitted_count", eqpKey: "eqp_submitted_count", count: 0 },
  { label: "Deleted", empKey: "deleted_count", eqpKey: "eqp_deleted_count", count: 0 },
  { label: "Saved", empKey: "saved_count", eqpKey: "eqp_saved_count", count: 0 },

])
const [allcounts,setAllCounts]=useState('')
// const formatDate = (date) => {
//   const localDate = date.toLocaleDateString('en-CA'); // gives 'YYYY-MM-DD' in most browsers
//   return localDate.split('/').join('-'); // Just in case fallback for some regions
// };

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


const fetchdata=async(status)=>{
    try {

      if(!status){
        setTableLoading(true);
      }
        
        const topcounts=await api.get('v1/timesheets/counts',{
          params: {
            start_date:formatDate(selectedDate), 
            company_id:companyid,
            supervisor_id: supervisorid,
                   },
        })
        if(topcounts.status===200){
          const apiData = topcounts?.data[0];
setAllCounts(apiData)
          setCounts(prevCounts =>
    prevCounts.map(item => ({
      ...item,
      count: apiData[tab === "emp" ? item.empKey : item.eqpKey] ?? 0,
    }))
        );
        
        }else{
          setCounts([]);
        }
        let obj={
          params: {
            start_date:formatDate(selectedDate), 
            company_id:companyid,
            supervisor_id: supervisorid,
            group_by:filterby.value      
          
          },
        }

        if (activeFilter == 'EQP' || activeFilter == 'EMP'||activeFilter.label == 'Equipments') {
          obj.params.status_type = null;
          if( tab==='eqp') {
            obj.params.etype = 'EQP';
          }else{
               obj.params.etype = activeFilter;
          }
       
        } else if (activeFilter.label !== 'All' && activeFilter.label !== '') {
          obj.params.status_type = activeFilter.label.toLocaleUpperCase();
        }
         if( tab==='eqp') {
            obj.params.etype = 'EQP';
          }else{
                obj.params.etype = 'EMP';
          }
        if(searchquery){
          obj.params.qsearch=searchquery.current
        }
       
        const response = await api.get("/v1/timesheets/search", obj);
        if (response.status === 200) {
let data =[]
if(!isoldbuild){


  data=response?.data||[]
}else{

//   data=Array.isArray(response?.data)
//   ? response.data.map(obj => {
// const convert = (dt) => {
//   if (!dt) return dt;
//   return dayjs.utc(dt).tz("America/Regina").format("YYYY-MM-DDTHH:mm:ss");


// };


//       return {
//         ...obj,
//         clock_in: convert(obj.clock_in),
//         clock_out: convert(obj.clock_out),
//       };
//     })
data = Array.isArray(response?.data)
  ? response.data.map((obj) => {
const convert = (dt) => {
  if (!dt) return dt;
  return dayjs
    .utc(dt)
    .tz("America/Regina")
    .add(1, "hour")
    .format("YYYY-MM-DDTHH:mm:ss");
};

      let rowInfo = {};
      try {
        rowInfo = obj?.row_info ? JSON.parse(obj.row_info) : {};
      } catch {
        rowInfo = {};
      }

      // const autoClockout =
      //   !(obj.clockout_pic && obj.clockin_pic) &&
      //   obj.clockout_pic !== obj.clockin_pic
      //     ? "Y"
      //     : "N";
const autoClockout =
  obj.clockin_pic && obj.clockout_pic && obj.clockin_pic === obj.clockout_pic
    ? "Y"
    : "N";
      rowInfo.autoClockout = autoClockout;


      return {
        ...obj,
        //       clock_in: autoClockout === "Y" ? obj.clock_in : convert(obj.clock_in),
        // clock_out: autoClockout === "Y" ? obj.clock_out : convert(obj.clock_out),
        clock_in:convert(obj.clock_in),
        clock_out: convert(obj.clock_out),
        row_info: JSON.stringify(rowInfo),
      };
    })
  
  : [];
}




        setEditedRows({})
          const groupedMap = new Map();

          data.forEach(item => {
            if (((item.status === "I" && item.is_split === 'Y')||(item.status == "I" && (item.is_split=='N')))&&activeFilter.label!=='Deleted') {
              return; // Skip this item
            }
            if (!groupedMap.has(item.emp_id)) {
              groupedMap.set(item.emp_id, []);
            }
            groupedMap.get(item.emp_id).push(item);
          });
             // Flatten grouped values while preserving first appearance order
          const reorderedData = Array.from(groupedMap.values()).flat();
        const updatedData = reorderedData.map(item => {
  return {
    ...item,
    cost_code_id: item.costcodeDescription === 'Overhead' ? '0000' : item.cost_code_id,
    job_id: item.jobDescription === 'Overhead' ? '0000' : item.job_id
  };
});
// if (
//   typeof activeFilter === "object" &&
//   activeFilter?.label === "All"
// ) {
//   const filteredData = updatedData.filter((item) => item.etype !== "EQP");
//   setTableData(filteredData);
// } else {
//   setTableData(updatedData);
// }
  // setTableData(updatedData);
const sortedData = [...updatedData].sort((a, b) => {
  return Number(b.id) - Number(a.id);
});

setTableData(sortedData);

       

          // setTableData(reorderedData);
        } else {
          setTableData([]);
        }
        
        
    } catch (error) {
        console.log(error);
    } finally {
      setTableLoading(false);
    }
}
const toTimeWithSeconds = (timeStr) => {
  if (!timeStr) return null;

  // Add ":00" if missing seconds
  if (/^\d{2}:\d{2}$/.test(timeStr)) {
    timeStr += ':00';
  }

  const match = timeStr.match(/^(\d{2}):(\d{2}):(\d{2})(\.\d+)?$/);
  if (!match) return null;

  const [, hours, minutes, seconds, millis = '.000'] = match;

  return `${hours}:${minutes}:${seconds}${millis}Z`;  // <- Only return time, no date
};
const submitEqpTimesheet=async(obj,id)=>{
try {
  setLoader(true)
 const response =await api.put('/v1/timesheets/multiple',{
    timesheet_ids:[id],
    ...obj
  })
if (response.status === 200) {
      setSeverity("success");
      setAlertMessage("Saved Successfully");
      setOpen(true);
      fetchdata(true);
    } else {
      setSeverity("info");
      setAlertMessage(response?.data?.message || "Unexpected response");
      setOpen(true);
    }
  
} catch (error) {
   console.log(error)
  setSeverity("error")
  setAlertMessage('something went wrong')
  setOpen(true)
}finally{
setLoader(false)
}

}
const updatemutiple=async(obj)=>{

try {
  setLoader(true)
  const response =await api.put('/v1/timesheets/multiple',{
    timesheet_ids:selectedRows,
    ...obj
  })
  await api.put('/v1/timesheets/status-update/SAVED',{
    timesheet_ids:selectedRows,
  })

  if(response.status==200){
  setSeverity("success")
  setAlertMessage('Timesheets Submitted Succesfully')
  setOpen(true)
    setFormData({
      clock_in: "",
      clock_out: "",
      job_id: "",
      cost_code_id: "",
      break_time: "",
      perdim: "",
    });
  setEditmodal(false)
  fetchdata(true)
  }else{
    setSeverity("info")
    setAlertMessage(response.message)
    setOpen(true)

  }
 
} catch (error) {
  console.log(error)
  setSeverity("error")
  setAlertMessage('something went wrong')
  setOpen(true)
}finally{ 
setLoader(false)
setEditedRows({})
setSelectedRows([])
}
}

const submitmultipletimesheets=async()=>{
  try {
    setLoader(true)
    const response =await api.put('/v1/timesheets/submit',{
      timesheet_ids:selectedRows
    })
    setSeverity("success")
    setAlertMessage('Updated Successfully')
    setOpen(true)
  } catch (error) {
    console.log(error)
  }finally{
    fetchdata(true)
setLoader(false)
setEditedRows({})
setSelectedRows([])
  }
}

const SavedAPI = async () => {
  setLoader(true); // Optional: start loader early

  try {
    const response = await api.put('/v1/timesheets/status-update/SAVED', {
      timesheet_ids: selectedRows,
    });

    if (response.status === 200) {
      setSeverity("success");
      setAlertMessage("Saved Successfully");
      setOpen(true);
      fetchdata(true);
    } else {
      setSeverity("info");
      setAlertMessage(response?.data?.message || "Unexpected response");
      setOpen(true);
    }
  } catch (error) {
    console.log(error);
    setSeverity("error");
    setAlertMessage("Something went wrong");
    setOpen(true);
  } finally {
    setLoader(false);
    setEditedRows({});
    setSelectedRows([]);
  }
};

const updatetimesheet = async (obj, id) => {
  try {
    let updatedObj = obj || {};
    setLoader(true);

    console.log(obj, "obj");

const toUTC = (time) => {
  if (!time) return time;

  const today = dayjs().format("YYYY-MM-DD");
  const fullTime = `${today} ${time}`; // "YYYY-MM-DD HH:mm"

  return dayjs.tz(fullTime, "YYYY-MM-DD HH:mm", "America/Regina") // UTC-6
    .utc() .subtract(1, "hour")
    .format("HH:mm");
};

    let payload = Object.keys(updatedObj).length > 0 ? updatedObj : {};

    if (Object.keys(payload).length === 0) {
      return;
    }

    // if (payload.clock_in) {
    //   payload.clock_in = toUTC(payload.clock_in);
    // }

    // if (payload.clock_out) {
    //   payload.clock_out = toUTC(payload.clock_out);
    // }
if (isoldbuild) {
if (payload.clock_in) {
    payload.clock_in = toUTC(payload.clock_in);
  }

  if (payload.clock_out) {
    payload.clock_out = toUTC(payload.clock_out);
  }
}

    console.log("FINAL PAYLOAD:", payload);

    const response = await api.put(`v1/timesheets/${id}`, payload);
    await api.put(`/v1/timesheets/${id}/SAVED`);

    if (response.status == 200) {
      setSeverity("success");
      setAlertMessage("Updated Successfully");
      setOpen(true);
      setEditedRows({});
      setSelectedRows([]);
      fetchdata(true);
      return true;
    } else {
      setSeverity("info");
      setAlertMessage(response?.message || "");
      setOpen(true);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoader(false);
  }
};

const handlesplit=async(timesheetid)=>{
  try {
    setLoader(true)
    const response = await api.post(`/v1/timesheets/split/${timesheetid}`)
    
  } catch (error) {
    console.log(error)
  }finally{
    fetchdata(true)
    setLoader(false)
    

  }

}
const handleclearclockout=async(id)=>{
  try {
    const response=await api.put(`/v1/timesheet/actions/clockout?timesheet_id=${id}`)
      if (response.status == 200) {
      setSeverity("success");
      setAlertMessage("Clockout Cleared Successfully");
      setOpen(true);
    
      fetchdata(true);
      return true;
    } else {
      setSeverity("info");
      setAlertMessage(response?.message || "");
      setOpen(true);
    }

  } catch (error) {
    console.log(error)

  }
}


const handleSearchQuery = (e) => {
  const value = e.target.value;
searchquery.current=value

  // Clear existing timer if any
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  // Set a new debounce timer
  const newTimer = setTimeout(() => {
    fetchdata();
  }, 2000); // 3 seconds delay

  setDebounceTimer(newTimer);
};


useEffect(() => {
  if(supervisorid&&filterby.name&&selectedDate&&tab){
     fetchdata();
  }  
    
  }, [supervisorid,filterby,selectedDate,activeFilter,tab,isoldbuild]);

useState(()=>{

},[isoldbuild])


    return(<>
    <div className="sm:pt-7 sm:px-8 mb-12">

<MainDashboardFilters 
tab={tab}
setEditedRows={setEditedRows}
activeFilter={activeFilter}
isDecimal={isDecimal} setIsDecimalMode={setIsDecimalMode}
group_by={filterby.value}
isoldbuild={isoldbuild}
setOldbuild={setOldbuild}
fetchdata={fetchdata}
setOpen={setOpen}
setAlertMessage={setAlertMessage}
setSeverity={setSeverity}
setSelectedRows={setSelectedRows}
setActiveFilter={setActiveFilter}
counts={counts}   selectedDate={selectedDate} setSelectedDate={setSelectedDate}  

   isDateRangeOpen={isDateRangeOpen} setIsDateRangeOpen={setIsDateRangeOpen}
         setFilterBy={setFilterBy}/>
<MainSearch 
editedRows={editedRows}
setEditedRows={setEditedRows}
searchquery={searchquery.current}

handlesearchquery={handleSearchQuery}
filterby={filterby} setFilterBy={setFilterBy}/>
{/* <div className="p-4 text-gray-600 font-normal text-sm text-start leading-5">
  Last edited by: John Doe
</div> */}



          <div className="flex flex-row border-b border-gray-300 mt-4">
  {/* Employee Tab */}
  <div
    className={`px-4 py-2 flex flex-row items-center gap-2 cursor-pointer 
      ${tab === "emp"
        ? "rounded-t-[8.75px] border-b-2 border-[#900] bg-[rgba(153,0,0,0.12)] shadow-[0_0_3px_0_rgba(0,0,0,0.15)]"
        : ""}`}
    onClick={() => {
       setSelectedRows([])
      setTab("emp")}}
  >
  <EmployeeIcon color={tab === "emp" ? "#900" : "gray"} />

    <span className={`${tab === "emp" ? "text-[#900]" : ""}`}>Employee</span>
    <span className={`${tab === "emp" ? "text-[#900]" : "text-gray-600"}`}>
      {allcounts?.total_count ? `(${allcounts.total_count})` : ""}
    </span>
  </div>

  {/* Equipment Tab */}
  <div
    className={`px-4 py-2 flex flex-row items-center gap-2 cursor-pointer 
      ${tab === "eqp"
        ? "rounded-t-[8.75px] border-b-2 border-[#900]  bg-[rgba(153,0,0,0.12)] shadow-[0_0_3px_0_rgba(0,0,0,0.15)]"
        : ""}`}
    onClick={() => {
      setSelectedRows([])
    setTab("eqp")}}
  >
<SettingIcon color={tab === "eqp" ? "#900" : "gray"} />

    <span className={`${tab === "eqp" ? "text-[#900]" : ""}`}>Equipment</span>
    <span className={`${tab === "eqp" ? "text-[#900]" : "text-gray-600"}`}>
      {allcounts?.eqp_all_count ? `(${allcounts.eqp_all_count})` : ""}
    </span>
  </div>
</div>

          

  {tableLoading ? (
          <div className="flex justify-center items-center h-40">
            <CircularProgress />
          </div>
        ) : (
          <div>
{tab=='eqp'?<EquipmentTable
submitEqpTimesheet={submitEqpTimesheet}
SavedAPI={SavedAPI}
isDecimal={isDecimal} setIsDecimalMode={setIsDecimalMode}
tab={tab}
setTab={setTab}
errorfields={errorfields}
setErrorFields={setErrorFields}
fetchdata={fetchdata}
setLoader={setLoader}
editedRows={editedRows}
setEditedRows={setEditedRows}
setMissingdatamodal={setMissingdatamodal}
selectedRows={selectedRows}
setSelectedRows={setSelectedRows}
setEditmodal={setEditmodal}
setOpen={setOpen}
setAlertMessage={setAlertMessage}
setSeverity={setSeverity}
handlesplit={handlesplit}
submitmultipletimesheets={submitmultipletimesheets} activeFilter={activeFilter}
updatetimesheet={updatetimesheet} filterby={filterby} setTableData={setTableData} tableData ={tableData}/>:<>
<CrudTable 
SavedAPI={SavedAPI}
tab={tab}
handleclearclockout={handleclearclockout}
setTab={setTab}
isDecimal={isDecimal} setIsDecimalMode={setIsDecimalMode}
errorfields={errorfields}
setErrorFields={setErrorFields}
fetchdata={fetchdata}
setLoader={setLoader}
editedRows={editedRows}
setEditedRows={setEditedRows}
setMissingdatamodal={setMissingdatamodal}
selectedRows={selectedRows}
setSelectedRows={setSelectedRows}
setEditmodal={setEditmodal}
setOpen={setOpen}
setAlertMessage={setAlertMessage}
setSeverity={setSeverity}
isoldbuild={isoldbuild}
handlesplit={handlesplit}
submitmultipletimesheets={submitmultipletimesheets} activeFilter={activeFilter}
updatetimesheet={updatetimesheet} filterby={filterby} setTableData={setTableData} tableData ={tableData}/>



</>}

            </div>

        )}
    </div>
  
    <MissingData ismodal={missingdatamodal} setismodal ={setMissingdatamodal}/>
    <EditSelected 
 
    activeFilter={activeFilter}
    setOpen={setOpen}
    tab={tab}
setAlertMessage={setAlertMessage}
setSeverity={setSeverity}
    formData={formData} setFormData={setFormData} tableData ={tableData} selectedRows={selectedRows} updatemutiple={updatemutiple} ismodal={editmodal} setismodal={setEditmodal} />
    <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>)
}
export default ViewTimeSheet;